import List from '@mui/material/List';
import { IssueItem } from '../IssueItem';
import {
  Typography,
} from '@mui/material';
import { IssueType } from '../IssueItem/types';

const sortByDate = (a: IssueType, b: IssueType) => a.date > b.date ? 1 : -1;

const IssuesList = ({issuesList}:{issuesList:any[]}) => {
  return issuesList.length > 0 ? (
    <List disablePadding sx={{ mb: 1 }}>
      {issuesList.sort(sortByDate).slice(0, 4).map((item, index) => (
        <IssueItem item={item} key={index} />
      ))}
    </List>
  ) : (
    <Typography
        fontSize={'13px'}
        variant={'body1'}
        color={'text.secondary'}
        sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}
    >
        No Issues found
    </Typography>
  );;
};

export { IssuesList };
